<script setup>
import {computed, defineEmits, onMounted, ref, toRef, watch} from 'vue';

const props = defineProps({
	clientId: String,
	authToken: { type: String, default: null }, // Optional token if already authenticated
	user: Object,
	presentationURL: String,
	open: {type: Boolean, default: false}
});


const authTokenRef = ref(props.authToken);

const openRef = toRef(props, 'open');
watch(openRef, (newValue) => {

	if (newValue) { // if TRUE, as in, the presentation URL is valid
		handleAuthClick();
		emit('opened-successfully');
	}
});



onMounted(() => {
	const script1 = document.createElement('script');
	script1.src = 'https://apis.google.com/js/api.js';
	script1.async = true;
	script1.defer = true;
	script1.onload = () => gapiLoaded();
	document.body.appendChild(script1);

	const script2 = document.createElement('script');
	script2.src = 'https://accounts.google.com/gsi/client';
	script2.async = true;
	script2.defer = true;
	script2.onload = () => gisLoaded();
	document.body.appendChild(script2);
});


let pickerInited = false;
let gisInited = false;

const gapiLoaded = () => {
	gapi.load('client:picker', initializePicker);
	console.log("GAPI LOADED");
};

async function initializePicker() {
	await gapi.client.load('https://www.googleapis.com/discovery/v1/apis/drive/v3/rest');
	pickerInited = true;
	console.log("PICKER INITIED");

	handleAuthClick();
	emit('opened-successfully');

}

const SCOPES = 'https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/presentations https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile openid';
let tokenClient;
const gisLoaded = () => {

	console.log("GIS LOADED");
	// this works, but it requests the "implicit grant" model which won't give me a refresh token in the future
	tokenClient = google.accounts.oauth2.initTokenClient({
		client_id: props.clientId,
		scope: SCOPES,
		callback: '', // defined later
	});

};

const emit = defineEmits(['guest-user-started', 'presentation-selected','opened-successfully','picker-opened']);



let accessToken = null;
const user = ref(null);
function handleAuthClick() {

	tokenClient.callback = async (response) => {
		if (response.error !== undefined) {
			throw (response);
		}


		console.log('successfully requested and got granted the following permissions:')
		console.log(response);
		accessToken = response.access_token;

		// THIS IS WHAT CREATES AND LOGS IN THE USER
		await loginWithGoogle(accessToken);
		console.log("Logged in silently with Google");
		// should I stealth log the user in from here? Else when I hande the "pick", the $request->user() on the backend is null

		await createPicker();
	};

	if (props.authToken == null) {
		// Prompt the user to select a Google Account and ask for consent to share their data
		// when establishing a new session.
		console.log("full request");
		emit('guest-user-started');

		let options;

		options = props.presentationURL || 'not_specified'

		// just redirect them to the Google Auth flow
		window.location.href = '/auth-google-redirect?presentation=' + options;
		// tokenClient.requestAccessToken({prompt: 'consent', access_type: 'offline'});

	} else {

		if (props.user?.google_auth_account?.scope?.includes("drive.file")) {

			console.log("user has the right scopes")

			if(new Date(props.user?.google_auth_account?.access_token_expiry) > new Date()) {

				console.log('access token is still valid ')

				accessToken = props.authToken;
				createPicker();

			} else {

				console.log("user has the right scopes, but their access token is expired so we need to silently refresh it");

				axios.post('/users/refreshToken')
					.then((response) => {
						console.log(response);
						accessToken = response.data;
						createPicker();
					})
					.catch((error) => {
						console.log(error)
						console.log('they probably has their auth reset, so lets do this the long way')
						tokenClient.requestAccessToken({prompt: 'consent'});
					});

			}
		} else {
			console.log('user is logged in but missing the right permission for the picker API');
			tokenClient.requestAccessToken({prompt: 'consent'});
		}

		// tokenClient.requestAccessToken({prompt: ''});
		// tokenClient.requestAccessToken();

	}

}

// only used if a user is doing a full request, so I don't know who they are, so I need to send access_token to backend to auth and log them in
async function loginWithGoogle(accessToken) {
	try {
		await axios.post('google-login',{accessToken: accessToken})
			.then((response) => {
				console.log("theyve been logged in silently");
			})
			.catch((error) => {
				console.log(error)
			});

		// return userInfo.email; // Returns the authenticated user's email
	} catch (error) {
		console.error("Error logging user in:", error);
	}
}



const presentationId = computed(() => {
	const match = props.presentationURL.match(/presentation\/d\/([^/]+)/);
	return match ? match[1] : '';
});

// actual code that shows the picker
function createPicker() {

	emit('picker-opened'); // send this back to the main component, so I can close any modals

	const allPresentationView = new google.picker.DocsView(google.picker.ViewId.PRESENTATIONS).setMode('LIST');

	if(props.presentationURL) {

		const specificPresentationView = new google.picker.DocsView(google.picker.ViewId.PRESENTATIONS).setFileIds(presentationId.value).setMode('LIST');

		const picker = new google.picker.PickerBuilder()
			.setOAuthToken(accessToken)
			.setAppId('147162821536')
			.hideTitleBar()
			.addView(specificPresentationView.setLabel('Filtered Presentation'))
			.addView(allPresentationView.setLabel('All Presentations'))
			.setCallback(pickerCallback)
			.setTitle('Grant SlideCub access to your presentation')
			.build();
		picker.setVisible(true);

		//.enableFeature(google.picker.Feature.NAV_HIDDEN)

	} else { // this means they didn't pass a presentation URL, so we can't pre-filter

		const picker = new google.picker.PickerBuilder()
			.setOAuthToken(accessToken)
			.setAppId('147162821536')
			.hideTitleBar()
			.addView(allPresentationView.setLabel('All Presentations'))
			.setCallback(pickerCallback)
			.setTitle('Grant SlideCub access to your presentation')
			.build();
		picker.setVisible(true);

	}

}




async function pickerCallback(data) {
	if (data.action === google.picker.Action.PICKED) {
		console.log('File chosen:', data);
		emit('presentation-selected',data,accessToken);
	} else {
		console.log(data);
	}
}


</script>

<template>

</template>
